import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../api/authApi';
import styles from './RegisterPage.module.css';
import global from '../styles/global.module.css';
import axios from 'axios';
import { formatPhone } from '../utils/phoneUtils';
import { useModal } from '../context/ModalContext';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const BASE_URL = `${API_URL}/api`;

const TERMS = {
    privacy: {
        label: '[필수] 개인정보 수집 및 이용 동의',
        content: `제1조 (수집하는 개인정보 항목)
종합센터몰은 회원가입 및 서비스 제공을 위해 아래와 같은 개인정보를 수집합니다.
- 필수항목: 이메일, 이름, 비밀번호, 전화번호
- 선택항목: 마케팅 수신 동의 여부

제2조 (개인정보 수집 및 이용 목적)
- 회원 식별 및 가입 의사 확인
- 서비스 제공 및 계약 이행 (주문, 결제, 배송)
- 고객 상담 및 불만 처리
- 법령상 의무 이행

제3조 (개인정보 보유 및 이용 기간)
- 회원 탈퇴 시까지
- 단, 관계 법령에 의해 보존이 필요한 경우 해당 기간 동안 보관
· 계약 또는 청약철회에 관한 기록: 5년 (전자상거래법)
· 대금결제 및 재화 공급에 관한 기록: 5년 (전자상거래법)
· 소비자 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)

제4조 (동의 거부 권리 및 불이익)
회원은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다.
단, 필수 항목 동의 거부 시 회원가입 및 서비스 이용이 제한됩니다.

사업자: 종합센터몰 | 대표자: 김선진 | 사업자등록번호: 755-32-01468
이메일: isunjin74@naver.com`
    },
    service: {
        label: '[필수] 서비스 이용약관 동의',
        content: `전자상거래 등에서의 소비자보호에 관한 법률 및 관련 법령에 따라 아래와 같이 이용약관을 고지합니다.

제1조 (목적)
본 약관은 종합센터몰(이하 "회사")이 운영하는 온라인 쇼핑몰에서 제공하는 인터넷 관련 서비스를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.

제2조 (사업자 정보)
- 상호: 종합센터몰
- 대표자: 김선진
- 사업자등록번호: 755-32-01468
- 이메일: isunjin74@naver.com
- 주소: 추후 기재 예정
- 전화번호: 추후 기재 예정

제3조 (약관의 효력 및 변경)
① 본 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게 공지함으로써 효력이 발생합니다.
② 회사는 합리적인 사유가 있을 경우 약관을 변경할 수 있으며, 변경된 약관은 공지사항을 통해 사전 고지합니다.
③ 이용자가 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.

제4조 (서비스 제공 및 변경)
① 회사는 다음과 같은 서비스를 제공합니다.
- 상품 판매 및 구매 중개
- 주문, 결제, 배송 서비스
- 기타 회사가 정하는 서비스
② 회사는 서비스의 내용을 변경할 수 있으며, 이 경우 변경 내용과 날짜를 사전에 공지합니다.

제5조 (회원 가입 및 탈퇴)
① 이용자는 회사가 정한 양식에 따라 회원 정보를 기입하고 본 약관에 동의함으로써 회원 가입을 신청합니다.
② 회원은 언제든지 탈퇴를 요청할 수 있으며, 회사는 즉시 탈퇴를 처리합니다.
③ 탈퇴 시 관련 법령에 따라 보존이 필요한 정보를 제외한 모든 개인정보는 삭제됩니다.

제6조 (이용자 의무)
① 이용자는 타인의 개인정보를 무단으로 수집, 이용, 제공하여서는 안 됩니다.
② 이용자는 회사의 서비스를 이용하여 불법적인 행위를 하여서는 안 됩니다.
③ 이용자는 계정 정보를 타인과 공유하거나 양도할 수 없습니다.

제7조 (청약철회 및 환불)
① 이용자는 상품 수령 후 7일 이내에 청약철회를 요청할 수 있습니다.
② 단, 다음의 경우 청약철회가 제한될 수 있습니다.
- 이용자의 사용 또는 일부 소비로 상품 가치가 현저히 감소한 경우
- 시간 경과로 재판매가 어려울 정도로 상품 가치가 감소한 경우
- 복제 가능한 상품의 포장을 훼손한 경우
③ 환불은 청약철회 확인 후 3영업일 이내에 처리됩니다.

제8조 (면책 조항)
① 회사는 천재지변, 불가항력적 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.
② 회사는 이용자의 귀책 사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.

제9조 (분쟁 해결)
① 회사와 이용자 간의 분쟁은 상호 협의를 통해 해결하는 것을 원칙으로 합니다.
② 협의가 이루어지지 않을 경우 소비자기본법에 따른 분쟁조정 기관에 조정을 신청할 수 있습니다.

부칙
본 약관은 2026년 1월 1일부터 시행합니다.`
    },
    marketing: {
        label: '[선택] 마케팅 정보 수신 동의',
        content: `종합센터몰은 아래와 같이 마케팅 정보 수신에 대한 동의를 받고 있습니다.

제1조 (수집 항목)
- 이메일, 전화번호

제2조 (수집 및 이용 목적)
- 신상품 및 서비스 안내
- 이벤트, 프로모션, 할인 정보 제공
- 맞춤형 광고 및 혜택 안내

제3조 (보유 및 이용 기간)
- 동의 철회 시까지
- 회원 탈퇴 시 즉시 파기

제4조 (동의 거부 권리 및 불이익)
마케팅 정보 수신 동의는 선택 사항입니다.
동의를 거부하더라도 회원가입 및 서비스 이용에는 아무런 제한이 없습니다.

수신 동의를 원하지 않으시면 마이페이지에서 언제든지 철회하실 수 있습니다.`
    }
};

function EyeIcon({ open }) {
    return open ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2">
            <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
            <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
        </svg>
    ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
        </svg>
    );
}

function PasswordStrength({ score }) {
    if (score === 0) return null;
    const colors = ['#e74c3c', '#f39c12', '#3498db', '#27ae60'];
    const labels = ['매우 약함', '약함', '보통', '강함'];
    const color = colors[score - 1];
    return (
        <div style={{ marginTop: '6px' }}>
            <div style={{ display: 'flex', gap: '4px' }}>
                {[1, 2, 3, 4].map(i => (
                    <div key={i} style={{
                        flex: 1, height: '4px', borderRadius: '2px',
                        background: i <= score ? color : '#eee'
                    }} />
                ))}
            </div>
            <p style={{ fontSize: '11px', marginTop: '4px', color }}>{labels[score - 1]}</p>
        </div>
    );
}

function TermsItem({ termKey, term, checked, onChange }) {
    const [expanded, setExpanded] = useState(false);
    return (
        <div className={styles.termItem}>
            <div className={styles.termHeader}>
                <label className={styles.termLabel}>
                    <input type="checkbox" checked={checked}
                        onChange={e => onChange(termKey, e.target.checked)}
                        className={styles.termCheckbox} />
                    {term.label}
                </label>
                <button type="button" className={styles.termToggle}
                    onClick={() => setExpanded(prev => !prev)}>
                    {expanded ? '접기 ▲' : '보기 ▼'}
                </button>
            </div>
            {expanded && <div className={styles.termContent}>{term.content}</div>}
        </div>
    );
}

function RegisterPage() {
    const navigate = useNavigate();
    const { showAlert } = useModal();
    const [form, setForm] = useState({ email: '', password: '', passwordConfirm: '', name: '', phone: '' });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [codeSent, setCodeSent] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [emailVerified, setEmailVerified] = useState(false);
    const [sendingCode, setSendingCode] = useState(false);
    const [verifyingCode, setVerifyingCode] = useState(false);
    const [allChecked, setAllChecked] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [terms, setTerms] = useState({ privacy: false, service: false, marketing: false });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        if (e.target.name === 'email') {
            setCodeSent(false); setEmailVerified(false); setVerificationCode('');
        }
    };

    const checkPasswordStrength = (pw) => {
        let score = 0;
        if (pw.length >= 8) score++;
        if (/[A-Z]/.test(pw)) score++;
        if (/[0-9]/.test(pw)) score++;
        if (/[^A-Za-z0-9]/.test(pw)) score++;
        setPasswordStrength(score);
    };

    const handleAllCheck = (e) => {
        const checked = e.target.checked;
        setAllChecked(checked);
        setTerms({ privacy: checked, service: checked, marketing: checked });
    };

    const handleTermChange = (key, checked) => {
        const updated = { ...terms, [key]: checked };
        setTerms(updated);
        setAllChecked(Object.values(updated).every(v => v));
    };

    const handleSendCode = async () => {
        if (!form.email) { setError('이메일을 입력해 주세요.'); return; }
        setSendingCode(true); setError('');
        try {
            await axios.post(`${BASE_URL}/email/send`, { email: form.email });
            setCodeSent(true);
            await showAlert('인증 코드가 발송되었습니다. 이메일을 확인해 주세요.', 'success');
        } catch {
            setError('이메일 발송에 실패했습니다.');
        } finally { setSendingCode(false); }
    };

    const handleVerifyCode = async () => {
        if (!verificationCode) { setError('인증 코드를 입력해 주세요.'); return; }
        setVerifyingCode(true); setError('');
        try {
            const res = await axios.post(`${BASE_URL}/email/verify`, { email: form.email, code: verificationCode });
            if (res.data.verified) {
                setEmailVerified(true);
                await showAlert('이메일 인증이 완료되었습니다.', 'success');
            }
        } catch {
            setError('인증 코드가 올바르지 않습니다.');
        } finally { setVerifyingCode(false); }
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); setError('');
        if (!emailVerified) { setError('이메일 인증을 완료해 주세요.'); return; }
        if (!terms.privacy || !terms.service) { setError('필수 약관에 동의해 주세요.'); return; }
        if (form.password !== form.passwordConfirm) { setError('비밀번호가 일치하지 않습니다.'); return; }
        try {
            await register({ email: form.email, password: form.password, name: form.name, phone: form.phone, marketingAgree: terms.marketing });
            setSuccess('회원가입이 완료되었습니다.');
            setTimeout(() => navigate('/login'), 1500);
        } catch { setError('이미 사용 중인 이메일입니다.'); }
    };

    const pwBtnStyle = {
        position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
        background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#888'
    };

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <h1 className={global.pageLogo}>SHOP</h1>
                <p className={global.pageSubtitle}>회원가입</p>
                {error && <p className={global.errorText}>{error}</p>}
                {success && <p className={global.successText}>{success}</p>}

                <form onSubmit={handleSubmit} className={styles.form}>
                    <input type="text" name="name" value={form.name}
                        onChange={handleChange} className={global.input} placeholder="이름" required />

                    <div className={styles.emailRow}>
                        <input type="email" name="email" value={form.email}
                            onChange={handleChange} className={global.input}
                            placeholder="이메일" required disabled={emailVerified} />
                        <button type="button" className={styles.codeBtn}
                            onClick={handleSendCode} disabled={sendingCode || emailVerified}>
                            {emailVerified ? '인증완료' : codeSent ? '재발송' : '인증요청'}
                        </button>
                    </div>

                    {codeSent && !emailVerified && (
                        <div className={styles.emailRow}>
                            <input type="text" value={verificationCode}
                                onChange={e => setVerificationCode(e.target.value)}
                                className={global.input} placeholder="인증 코드 6자리" maxLength={6} />
                            <button type="button" className={styles.codeBtn}
                                onClick={handleVerifyCode} disabled={verifyingCode}>
                                {verifyingCode ? '확인 중...' : '확인'}
                            </button>
                        </div>
                    )}

                    {/* 비밀번호 */}
                    <div>
                        <div style={{ position: 'relative' }}>
                            <input type={showPassword ? 'text' : 'password'} name="password" value={form.password}
                                onChange={e => { handleChange(e); checkPasswordStrength(e.target.value); }}
                                className={global.input}
                                placeholder="비밀번호 (8자 이상, 대문자/숫자/특수문자 포함)" required
                                style={{ paddingRight: '44px' }} />
                            <button type="button" onClick={() => setShowPassword(p => !p)} style={pwBtnStyle}>
                                <EyeIcon open={showPassword} />
                            </button>
                        </div>
                        <PasswordStrength score={passwordStrength} />
                    </div>

                    {/* 비밀번호 확인 */}
                    <div style={{ position: 'relative' }}>
                        <input type={showPasswordConfirm ? 'text' : 'password'} name="passwordConfirm" value={form.passwordConfirm}
                            onChange={handleChange} className={global.input}
                            placeholder="비밀번호 확인" required style={{ paddingRight: '44px' }} />
                        <button type="button" onClick={() => setShowPasswordConfirm(p => !p)} style={pwBtnStyle}>
                            <EyeIcon open={showPasswordConfirm} />
                        </button>
                    </div>

                    <input type="tel" name="phone" value={form.phone}
                        onChange={e => setForm({ ...form, phone: formatPhone(e.target.value) })}
                        className={global.input} placeholder="전화번호 (010-0000-0000)" maxLength={13} />

                    <div className={styles.termsBox}>
                        <label className={styles.allCheckLabel}>
                            <input type="checkbox" checked={allChecked}
                                onChange={handleAllCheck} className={styles.termCheckbox} />
                            전체 동의
                        </label>
                        <div className={styles.termDivider} />
                        {Object.entries(TERMS).map(([key, term]) => (
                            <TermsItem key={key} termKey={key} term={term}
                                checked={terms[key]} onChange={handleTermChange} />
                        ))}
                    </div>

                    <button type="submit" className={global.btnPrimary}>가입하기</button>
                </form>

                <div className={global.divider} />
                <Link to="/login" className={global.btnOutline}>로그인으로 돌아가기</Link>
            </div>
        </div>
    );
}

export default RegisterPage;